import * as React from 'react';

import { PageIndicationSlot } from '../../locations';

export default function PageIndicationLocation() {
	return <PageIndicationSlot />;
}
